import {Box,Link,Typography} from '@mui/material';
import COMPONENT_MAP from "./Repository/Components";
import {consoleLog} from '../utilities/Utilities';
import backgroundImageCoda from "../assets/backgroundCoda.jpg";
const file='About.js';

const About=({aboutCallback,application})=>{

    const handleClickEvent=(args)=>{
        consoleLog({file:file,context:'handleClickEvent',arg_name:'args',arg_value:args});
        switch(args?.action){
            case "close_popup":
                aboutCallback();
                break;
            default:
                break;
        }
    }

    const componentBody=
    <Box
        sx={{
            position:'relative',
            overflow:'hidden',
            marginTop:'-35px',
            marginBottom:'-15px',
            paddingTop:'10px',
            zIndex:0,
            '&::before':{
                content:'""',
                position:'absolute',
                top:0,
                left:0,
                width:'100%',
                height:'100%',
                backgroundImage:`url(${backgroundImageCoda})`,
                backgroundSize:'cover',
                backgroundPosition:'center',
                opacity:0.2,
                zIndex: -1,
            },
        }}>
        <Typography variant="h1" style={{width:'fit-content',color:'#00224F',paddingBottom:'5px',paddingRight:'10px',fontWeight:'500',fontSize:'3.00rem',marginLeft:'auto',marginRight:'auto',textAlign:'center'}}>Coda Engineering</Typography>
        <Typography variant="h6" style={{margin:'5px',fontWeight:'300',fontSize:'1.00rem'}}>{application.getLocale("AboutPlatform")}<span className="body-title">{'Coda Core'}</span></Typography>
        <Typography variant="h6" style={{margin:'5px',fontWeight:'300',fontSize:'1.00rem'}}>{application.getLocale("AboutVersion")}<span className="body-title">{'2.0.0 (28.09.2025)'}</span></Typography>
        <Typography variant="h6" style={{margin:'5px',fontWeight:'300',fontSize:'1.00rem'}}>{application.getLocale("AboutWebsite")}<Link style={{color:'#00224F',fontWeight:'bold'}} href="https://coda.engineering" target="_blank" underline="hover">coda.engineering</Link></Typography>
    </Box>
    
    const renderDetailFormPopup=()=>{
        const Component=COMPONENT_MAP['DetailFormPopup'];
        return Component?(
            <Component
                key={'DetailFormPopup'}
                title={application.getLocale("AboutTitle")}
                application={application}
                handleClickEvent={handleClickEvent}
                isChanged={false}
                componentBody={componentBody}
                readOnly={true}
                recordRules={null}
            />
        ):null; 
    };

    return (renderDetailFormPopup());
}

export default About;
